import * as React from 'react';
import { HostedWebContentSdkService } from '../Services/hosted-web-content-sdk';
import { AppInitState, } from '../Services/hosted-web-content-sdk.interface';
export var useCreateAppHostSdk = function (host, context, hubServices, appDefinition, communicationBridge, hostVersionInfo) {
    var _a = React.useState({
        state: AppInitState.Unknown,
    }), appInitInfo = _a[0], setAppInitInfo = _a[1];
    React.useEffect(function () {
        // whenever the appDefinition changes we should reset the appInitState as seen by the Container
        // this way if the previous app failed, we won't prevent the new one from being loaded
        if (appInitInfo.state === AppInitState.Failed) {
            setAppInitInfo({ state: AppInitState.Unknown });
        }
    }, [appDefinition]);
    var appHostSdk = React.useMemo(function () {
        return new HostedWebContentSdkService(host, communicationBridge, context, hubServices, setAppInitInfo, hostVersionInfo);
    }, [host, context.page.frameContext, setAppInitInfo, context.app.host.clientType, hostVersionInfo]);
    return { appHostSdk: appHostSdk, appInitInfo: appInitInfo };
};
//# sourceMappingURL=use-create-app-host-sdk.js.map